// @flow
import React from "react";
import TerminalSelection from "./TerminalSelection";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { strings, images } from "../../../../config";
import CurrentRequestSelectors from "../../../../Store/Ducks/CurrentRequest/selectors";
import CurrentRequestOperations from "../../../../Store/Ducks/CurrentRequest/operations";

type ConnectedProps = {
    polygon: Object,
    terminalStops: Array<Object>,
};

type OwnProps = {
    onSelectDestTerminal: () => mixed,
};

const DestTerminalSelection = (props: OwnProps & ConnectedProps) => {
    return (<TerminalSelection
        terminalSelectionLogo={images.terminal_selection_dest_title_icon}
        selectionTitle={strings.manual_stop_dest_selection_title}
        onTerminalSelect={props.onSelectDestTerminal}
        polygon={props.polygon}
        terminalStops={props.terminalStops}
    />);
};

const mapStateToProps = state => {
    return {
        polygon: CurrentRequestSelectors.getDestPolygonSelector(state),
        terminalStops: CurrentRequestSelectors.getDestAirportTerminals(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onSelectDestTerminal: CurrentRequestOperations.selectDest
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapActionsToProps)(DestTerminalSelection);



// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/TerminalSelection/DestTerminalSelection.js